import { Service } from "typedi";
import {
  ChangePasswordBody,
  ChangePasswordResponse,
  FetchCodeDetailsResponse,
  FetchSessionResponse,
  LoginBody,
  LoginResponse,
} from "@flosum-auth/contracts";
// TODO: fix as soon as possible
// eslint-disable-next-line import/no-cycle
import { RestService } from "~shared/services/rest.service";

@Service()
export class AuthService {
  constructor(private readonly restService: RestService) {}

  public login(body: LoginBody): Promise<LoginResponse> {
    return this.restService.post("/v1/auth/login", body);
  }

  public logout(): Promise<void> {
    return this.restService.get("/v1/auth/logout");
  }

  public changePassword(body: ChangePasswordBody): Promise<ChangePasswordResponse> {
    return this.restService.patch("/v1/auth/change-password", body);
  }

  public fetchCodeDetails(code: string): Promise<FetchCodeDetailsResponse> {
    return this.restService.get(`/v1/auth/change-password/${code}`);
  }

  public fetchSession(): Promise<FetchSessionResponse> {
    return this.restService.get("/v1/auth/session");
  }
}
